import { Trans, t } from "@lingui/macro";
import { Room } from "../../models/Room";
import { My } from "../../services/My";
import { UtilApp } from "../../services/Utils/UtilApp";

export const RoomWelcomeMessage: React.FC<{ room: Room }> = ({ room }) => {
    const creatorName = room.users.find(u => u.id == room.creatorId)?.name ?? t`a user`;
    const roomName = room.name;
    // room.created는 Firestore Timestamp일 수 있으므로 안전하게 변환
    const createdDate = room.created
        ? (typeof (room.created as any).toDate === 'function'
            ? (room.created as any).toDate()
            : new Date(room.created as any))
        : new Date();
    const date = UtilApp.dateStrToTimeAndDay(createdDate.toISOString(), My.user.lang);

    return (
        <div className="flex flex-col items-center justify-center flex-1 py-4 w-full">
            <div className="flex flex-col gap-8 items-start justify-center w-full max-w-[700px] px-4">
                {/* Greeting Text Container */}
                <div className="flex flex-col gap-8 items-start justify-center w-full">
                    {/* Logo Icon — 80px, Figma Export */}
                    <img
                        src="assets/icon/welcome-logo.png"
                        alt="NextPOD"
                        className="size-20 rounded-full object-contain"
                        onError={(e) => {
                            (e.target as HTMLImageElement).src = 'assets/icon/favicon.png';
                        }}
                    />

                    {/* Greeting & Date */}
                    <div className="flex flex-col gap-2 items-start">
                        <p className="text-display-2xl font-normal text-[color:rgb(var(--text-body))]">
                            <Trans>Welcome to #{roomName}</Trans>
                        </p>
                        <p className="text-display-md leading-normal tracking-[-0.2px] font-light text-[color:rgb(var(--text-body))]">
                            <Trans>Created by {creatorName}</Trans> • {date}
                        </p>
                    </div>
                </div>

                {/* Options Container — 두 개의 수평 카드 */}
                <div className="flex gap-3 items-center w-full">
                    {/* Card 1: 멤버, 파일, 메모 — Officewave/Outline/txt-box */}
                    <div className="flex-1 flex flex-col gap-5 items-start justify-center overflow-hidden p-4 rounded-xl bg-muted border border-border">
                        <svg width="20" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-muted-foreground shrink-0">
                            <path d="M11 5.16667H6M8.5 11.8333H6M11 8.5H6M16 8.94118C16 14.3333 14.3333 16 8.5 16C2.66667 16 1 14.3333 1 8.5C1 2.66667 2.66667 1 8.5 1C14.3333 1 16 2.66667 16 8.94118Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <div className="flex flex-col gap-2 items-start text-sm leading-5 w-full">
                            <p className="text-[color:rgb(var(--text-body))]">
                                <Trans>Members, Files, Memos</Trans>
                            </p>
                            <p className="text-muted-foreground">
                                <Trans>Check the right panel for members, files, and memos.</Trans>
                            </p>
                        </div>
                    </div>
                    {/* Card 2: 메시지 확인 */}
                    <div className="flex-1 flex flex-col gap-5 items-start justify-center overflow-hidden p-4 rounded-xl bg-muted border border-border">
                        <svg width="20" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-muted-foreground shrink-0">
                            <path d="M5.5 8.5H5.50749M8.49625 8.5H8.50374M11.4925 8.5H11.5M7.75 1H9.25C13.5 1 16 3.91667 16 8.5C16 13.0833 12.9779 16 9.25 16H4C2.34315 16 1 14.5076 1 12.6667V8.5C1 4.35786 3.5 1 7.75 1Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <div className="flex flex-col gap-2 items-start text-sm leading-5 w-full">
                            <p className="text-[color:rgb(var(--text-body))]">
                                <Trans>Message History</Trans>
                            </p>
                            <p className="text-muted-foreground">
                                <Trans>Messages posted before you joined this channel are not visible.</Trans>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}